import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-button',
  styles: [require('./app-button.component.scss')],
  template: require('./app-button.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
})
export class AppButtonComponent {
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() style: 'primary' | 'secondary' = 'primary';

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>()
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/app-button/app-button.component.ts